import { render, staticRenderFns } from "./EstoqueSolicitacaoAutorizar.vue?vue&type=template&id=1307a0de&"
import script from "./EstoqueSolicitacaoAutorizar.vue?vue&type=script&lang=js&"
export * from "./EstoqueSolicitacaoAutorizar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports